import { createMemoStyles } from '@wds/utils';
import { HeaderTheme } from '../../theme';

type NotificationItemStyleProps = {
  read?: boolean;
};

const useStyles = createMemoStyles(({ spacing, palette }: HeaderTheme) => ({
  notificationsItem: ({ read }: NotificationItemStyleProps) => ({
    padding: [spacing[4], spacing[4], spacing[4], 40],
    borderBottom: [1, 'solid', palette.border.muted],
    position: 'relative',
    whiteSpace: 'normal',

    '& a': {
      textDecoration: 'underline',
    },

    '& abbr': {
      textDecoration: 'underline',
      textDecorationStyle: 'dotted',
    },

    '&:before': {
      display: 'none',
    },

    '&:after': {
      content: '""',
      position: 'absolute',
      left: 0,
      bottom: -1,
      width: 40,
      height: 1,
      backgroundColor: '#fff',
    },

    ...(!read && {
      '&:before': {
        position: 'absolute',
        height: spacing[2],
        width: spacing[2],
        borderRadius: '50%',
        backgroundColor: palette.error.main,
        content: '""',
        top: 57,
        transform: 'translateY(-4px)',
        left: spacing[4],
      },
      '&:hover': {
        backgroundColor: palette.background.accent,
      },
    }),
  }),
}));

export default useStyles;
